import { render, staticRenderFns } from "./Flashs.vue?vue&type=template&id=5bdaaeb5"
import script from "./Flashs.vue?vue&type=script&lang=js"
export * from "./Flashs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports